import Api from "./Api";

export default {
    getConversationsAverage(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/conversations/average`, { params });
    },
    getConversationsTimeline(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/conversations/timeline`, { params });
    },
    getAgentAnalytics(database_uuid, agent_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/agents/${agent_uuid}/conversations/analytics`, { params });
    },
    getMessagesAverage(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/messages/average`, { params });
    },
    getMessagesTimeline(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/messages/timeline`, { params });
    },
    getAgentMessagesAnalytics(database_uuid, agent_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/agents/${agent_uuid}/messages/analytics`, { params });
    },
    getMessageRoleDistribution(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/messages/role-distribution`, { params });
    },
    getMessageAttachmentAnalytics(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/messages/attachment-analytics`, { params });
    },
    getAttachmentsInStockCards(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/attachments/cards/in-stock`, { params });
    },
    getAttachmentsOutStockCards(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/attachments/cards/out-of-stock`, { params });
    },
    getAttachmentsMaps(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/attachments/maps`, { params });
    },
    getAttachmentsTypeDistribution(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/attachments/distribution/type`, { params });
    },
    getAttachmentsStockStatus(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/attachments/distribution/stock-status`, { params });
    },
    getUserConversationsAnalytics(database_uuid, user_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/users/${user_uuid}/conversations/analytics`, { params });
    },
    getUserMessagesAnalytics(database_uuid, user_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/users/${user_uuid}/messages/analytics`, { params });
    },
    getCartConversion(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/cart/conversion`, { params });
    },
    getCartTimeline(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/cart/timeline`, { params });
    },
    getCartProductMovements(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/cart/products/movements`, { params });
    },
    getCartProductAbandonment(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/cart/products/abandonment`, { params });
    },
    getCartCoOccurrence(database_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/cart/co-occurrence`, { params });
    },
    getDeviceCartJourney(database_uuid, device_uuid, params = {}) {
        return Api().get(`proxy/ai/api/analytics/company/${database_uuid}/devices/${device_uuid}/cart/journey`, { params });
    },
};
